import { render, staticRenderFns } from "./ProductBrandComponent.vue?vue&type=template&id=8627e712&scoped=true"
import script from "./ProductBrandComponent.vue?vue&type=script&lang=js"
export * from "./ProductBrandComponent.vue?vue&type=script&lang=js"
import style0 from "./ProductBrandComponent.vue?vue&type=style&index=0&id=8627e712&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8627e712",
  null
  
)

export default component.exports